import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource/oswald/500.css';
import '@fontsource/oswald/600.css';
import { App } from './App';
import { initializeFontSizePreference } from './font-size';
import './styles.css';
import './product-catalog.css';
import './mobile-usable.css';
import './staff-mobile.css';

initializeFontSizePreference();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
